/* Aleefy Motion Layer — everything moves, nothing breaks. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  function mm(q) { return window.matchMedia ? window.matchMedia(q).matches : false; }
  if (mm('(prefers-reduced-motion: reduce)')) return;
  var fine = mm('(hover: hover) and (pointer: fine)');
  var canAnimate = !!(d.body && d.body.animate);
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  d.body.classList.add('mo-ready');

  /* ---- scroll progress + header shadow ---- */
  var bar = d.createElement('div');
  bar.className = 'mo-progress';
  bar.setAttribute('aria-hidden', 'true');
  d.body.appendChild(bar);
  var head = d.getElementById('shopify-section-header');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = root.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(1, window.scrollY / h) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      if (head) head.classList.toggle('mo-scrolled', window.scrollY > 10);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- floating paws in the background ---- */
  var bg = d.createElement('div');
  bg.className = 'mo-bg';
  bg.setAttribute('aria-hidden', 'true');
  var icons = ['🐾', '🦴', '🐾', '💛', '🐾', '⭐', '🐟', '🐾'];
  var count = window.innerWidth < 700 ? 8 : 16;
  for (var i = 0; i < count; i++) {
    var s = d.createElement('span');
    s.textContent = icons[i % icons.length];
    s.style.left = (Math.random() * 96) + '%';
    s.style.fontSize = (16 + Math.random() * 30) + 'px';
    s.style.animationDuration = (18 + Math.random() * 20) + 's';
    s.style.animationDelay = (-Math.random() * 38) + 's';
    bg.appendChild(s);
  }
  d.body.appendChild(bg);

  /* ---- stagger indexes ---- */
  $$('.nav .chip').forEach(function (el, i) { el.style.setProperty('--i', i); });
  $$('.trust > div').forEach(function (el, i) { el.style.setProperty('--i', i); });
  $$('.prod .prod-img img, .prod .prod-img > span[aria-hidden]').forEach(function (el, i) {
    el.style.animationDelay = (-(i % 5) * 0.9) + 's';
  });

  /* ---- reveal on scroll ---- */
  var groups = [
    ['.sec, .wa, .pd, .co, .page-h, .empty, .site-foot, .crumb, .filters, .pager', 'mo-r'],
    ['.prod, .cat, .trust > div, .box, .thumb', 'mo-r mo-zoom']
  ];
  var watched = [];
  groups.forEach(function (g) {
    $$(g[0]).forEach(function (el) {
      if (el.closest('.drawer')) return;
      g[1].split(' ').forEach(function (c) { el.classList.add(c); });
      var idx = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      el.style.setProperty('--d', ((idx % 8) * 90) + 'ms');
      watched.push(el);
    });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mo-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    watched.forEach(function (el) { io.observe(el); });
  } else {
    watched.forEach(function (el) { el.classList.add('mo-in'); });
  }
  // Safety net: never leave anything hidden.
  setTimeout(function () { watched.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight) el.classList.add('mo-in');
  }); }, 2500);

  /* ---- 3D tilt + glare (mouse only) ---- */
  if (fine) {
    $$('.prod').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        var k = el.classList.contains('pd-img') ? 6 : 12;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * k) + 'deg) rotateY(' + (x * k) + 'deg)';
        el.style.setProperty('--mx', ((x + 0.5) * 100) + '%');
        el.style.setProperty('--my', ((y + 0.5) * 100) + '%');
        el.classList.add('mo-tilt');
      });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
        el.classList.remove('mo-tilt');
      });
    });

    /* magnetic buttons */
    $$('.btn, .cart-btn, .add, .x').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width / 2);
        var y = e.clientY - (r.top + r.height / 2);
        el.style.translate = (x * 0.22) + 'px ' + (y * 0.3) + 'px';
      });
      el.addEventListener('pointerleave', function () { el.style.translate = ''; });
    });
  }

  /* ---- paw burst on every tap ---- */
  function burst(x, y, n, chars) {
    if (!canAnimate) return;
    chars = chars || ['🐾'];
    for (var k = 0; k < n; k++) {
      var p = d.createElement('span');
      p.className = 'mo-spark';
      p.setAttribute('aria-hidden', 'true');
      p.textContent = chars[k % chars.length];
      p.style.left = x + 'px';
      p.style.top = y + 'px';
      d.body.appendChild(p);
      var a = (Math.PI * 2 * k) / n + Math.random() * 0.6;
      var dist = 40 + Math.random() * 55;
      var dx = Math.cos(a) * dist, dy = Math.sin(a) * dist - 20;
      var rot = (Math.random() * 120 - 60);
      var anim = p.animate([
        { transform: 'translate(-50%,-50%) scale(.3)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(1) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 650 + Math.random() * 350, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  }
  d.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (e.target.closest && e.target.closest('input, select, textarea')) return;
    burst(e.clientX, e.clientY, 6);
  }, { passive: true });

  /* ---- product flies into the cart ---- */
  function flyToCart(fromEl) {
    var cart = d.querySelector('.cart-btn');
    if (!fromEl || !cart || !canAnimate) return;
    var a = fromEl.getBoundingClientRect(), c = cart.getBoundingClientRect();
    if (!a.width) return;
    var clone = fromEl.cloneNode(true);
    clone.removeAttribute('loading');
    clone.removeAttribute('srcset');
    clone.removeAttribute('style');
    clone.className = 'mo-fly';
    clone.setAttribute('aria-hidden', 'true');
    clone.style.left = a.left + 'px';
    clone.style.top = a.top + 'px';
    clone.style.width = a.width + 'px';
    clone.style.height = a.height + 'px';
    d.body.appendChild(clone);
    var dx = c.left + c.width / 2 - (a.left + a.width / 2);
    var dy = c.top + c.height / 2 - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px) scale(.55) rotate(-18deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08) rotate(25deg)', opacity: 0.4 }
    ], { duration: 900, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () {
      clone.remove();
      burst(c.left + c.width / 2, c.top + c.height / 2, 10, ['🐾', '💛', '⭐']);
    };
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]');
    if (!b) return;
    var card = b.closest('.prod');
    flyToCart(card && card.querySelector('.prod-img img, .prod-img > span[aria-hidden]'));
  });
  d.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest('form[data-product-form]')) return;
    flyToCart(d.querySelector('[data-main-image-wrap] img, .pd-img img, .pd-img > span'));
  });

  /* ---- cart count pops when it changes ---- */
  if ('MutationObserver' in window) {
    $$('[data-cart-count]').forEach(function (el) {
      new MutationObserver(function () {
        el.classList.remove('mo-pop'); void el.offsetWidth; el.classList.add('mo-pop');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---- search box types suggestions ---- */
  var search = d.querySelector('.search input[type="search"]');
  if (search) {
    var ideas = ['Search cozy beds…', 'Search dog houses…', 'Search cat toys…', 'Search food & treats…', search.getAttribute('placeholder') || 'Search…'];
    var wi = 0, ci = 0, del = false, paused = false;
    search.addEventListener('focus', function () { paused = true; search.setAttribute('placeholder', ideas[ideas.length - 1]); });
    search.addEventListener('blur', function () { paused = false; });
    (function type() {
      if (!paused && !search.value) {
        var w = ideas[wi];
        ci += del ? -1 : 1;
        search.setAttribute('placeholder', w.slice(0, Math.max(0, ci)) + '|');
        if (!del && ci >= w.length) { del = true; setTimeout(type, 1600); return; }
        if (del && ci <= 0) { del = false; ci = 0; wi = (wi + 1) % ideas.length; }
      }
      setTimeout(type, del ? 35 : 75);
    })();
  }
})();
